const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Shares Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('AvailableCopy', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
    return $resource(appConfiguration.apiUrl + '/v3/available-copy/:subresource/:action', null, {
      get: {params: {subresource: '', action: ''}, method: 'GET', isArray: true},
    });
}])